import cx from 'classnames'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

import Styles from './Header.module.scss'

export const Header = ({
  className,
  header,
  subHeader,
  isRequired,
}: {
  className?: string
  header?: string
  subHeader?: string
  isRequired?: boolean
}) => {
  if (!header && !subHeader) return null

  const title = (
    <span>
      {header}
      {isRequired && <span className={Styles.star}>&nbsp;*</span>}
    </span>
  )

  return (
    <div className={cx(Styles.header, className)}>
      {header && <Heading level={4}>{title}</Heading>}
      {subHeader && (
        <Text color="var(--dark-80)" variant="secondary">
          {subHeader}
        </Text>
      )}
    </div>
  )
}
